import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Card from 'react-bootstrap/Card';


class EX2secondaire extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="danger">
            <h3>
              Exercices pour le deuxième année secondaire.
            </h3>
          </Alert>

          <Row>
              <MyCard
              title="Les nomvres relatifs"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/nombre_relatifs.pdf" />

              <MyCard
              title="Les nombres rationnels: introduction et comparaison"
               ty="Exercice"
               color1="#f7f2ee"
               content=""
               fileUrl="/documents/file/pdf/2/exercice/nombresrationnel.pdf" />

              <MyCard
              title="La symétrie axiale"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/axiale.pdf" />
          </Row>

          <Row>
              <MyCard
              title="Nombres rationnels: somme et différence"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/nombres_rat_som_diff.pdf" />

              <MyCard
              title="Nombres rationnels: produit et quotient"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/nombres_rat_pro_div.pdf" />


              <MyCard
              title="Triangles et parallèle"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/parallele.pdf" />
          </Row>



          <Row>
              <MyCard
              title="Les droites remarquables"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/remarquable.pdf" />

              <MyCard
              title="Les puissances"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/puissance.pdf" />


              <MyCard
              title="Les équations"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/equations.pdf" />
          </Row>



          <Row>
              <MyCard
              title="Le calcul littéral"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/calcule_letiral.pdf" />

              <MyCard
              title="Ordre et opérations"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/ordre.pdf" />


              <MyCard
              title="Triangle rectangle et cercle"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/triangle_rec_cercle.pdf" />
          </Row>



          <Row>
              <MyCard
              title="Statistique"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/statistique.pdf" />

              <MyCard
              title="Vecteurs et translation"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/vec_trans.pdf" />


              <MyCard
              title="Volumes"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/volumes.pdf" />
          </Row>


          <Row>
              <MyCard
              title="Proportionalité"
              ty="Exercice"
              color1="#f7f2ee"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/propo.pdf" />


          </Row>


      </div>
    );
  }
}

export default EX2secondaire;
